import { render } from "./OFAC.vue?vue&type=template&id=b93ca532&scoped=true"
import script from "./OFAC.vue?vue&type=script&lang=js"
export * from "./OFAC.vue?vue&type=script&lang=js"

import "./OFAC.vue?vue&type=style&index=0&id=b93ca532&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b93ca532"

export default script